import { SearchUserEventsRequestDtoOperationsEnum } from 'lib_api/lib/api/gen';

export const userEventOperationsMapping: {
  [key in SearchUserEventsRequestDtoOperationsEnum]: string;
} = {
  [SearchUserEventsRequestDtoOperationsEnum.CREATE]: 'Création',
  [SearchUserEventsRequestDtoOperationsEnum.DELETE]: 'Suppression',
};
